/**
 * @author Milton Filho
 */

/**
 * Present in the API's `Access-Control-Allow-Headers` in production, verified
 *   directly rather than taken on trust: a custom header missing from the
 *   preflight response is not a degraded feature, it is a POST the browser
 *   never sends, with no trace in the backend log.
 */
export const IDEMPOTENCY_KEY_HEADER = 'Idempotency-Key';
